import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClipboardList } from "lucide-react";
import CustomerLayout from "@/components/customer/CustomerLayout";
import { StatusBadge, EmptyState } from "@/components/common";
import { api, inr } from "@/lib/api";

const TABS = [["active", "Active"], ["completed", "Past"], ["cancelled", "Cancelled"]];

export default function Orders() {
  const nav = useNavigate();
  const [orders, setOrders] = useState(null);
  const [tab, setTab] = useState("active");
  useEffect(() => { api.get("/orders").then((r) => setOrders(r.data)).catch(() => {}); }, []);

  const filter = (o) => {
    if (tab === "cancelled") return o.status === "cancelled";
    if (tab === "completed") return o.status === "delivered";
    return !["delivered", "cancelled"].includes(o.status);
  };
  const list = (orders || []).filter(filter);

  return (
    <CustomerLayout>
      <div className="sticky top-0 z-40 bg-white border-b border-border px-4 pt-4">
        <h1 className="font-display font-extrabold text-2xl text-ink">Your Orders</h1>
        <div className="flex gap-2 mt-3">
          {TABS.map(([k, l]) => <button key={k} onClick={() => setTab(k)} className={`px-4 py-2 text-sm font-semibold border-b-2 ${tab === k ? "border-coral text-coral" : "border-transparent text-ink-600"}`} data-testid={`orders-tab-${k}`}>{l}</button>)}
        </div>
      </div>
      <div className="px-4 py-4 space-y-3">
        {!orders ? [0, 1].map((i) => <div key={i} className="skel h-28 rounded-2xl" />) :
          list.length === 0 ? <EmptyState icon={ClipboardList} title="No orders here" subtitle="Your orders will show up here." cta="Order now" onCta={() => nav("/")} /> :
            list.map((o) => (
              <button key={o.id} onClick={() => nav(`/order/${o.id}`)} className="w-full bg-white rounded-2xl border border-border p-4 text-left tap" data-testid={`order-${o.id}`}>
                <div className="flex items-center gap-3">
                  <img src={o.restaurant_image} alt="" className="w-12 h-12 rounded-xl object-cover" />
                  <div className="flex-1 min-w-0"><div className="font-bold text-ink truncate">{o.restaurant_name}</div><div className="text-xs text-ink-600">{o.code} · {new Date(o.created_at).toLocaleDateString()}</div></div>
                  <StatusBadge status={o.status} />
                </div>
                <div className="text-xs text-ink-600 mt-2 truncate">{o.items.map((i) => `${i.qty}× ${i.name}`).join(", ")}</div>
                <div className="flex items-center justify-between mt-2"><span className="font-bold text-sm">{inr(o.total)}</span><span className="text-coral font-semibold text-sm">{["delivered", "cancelled"].includes(o.status) ? "Reorder →" : "Track →"}</span></div>
              </button>
            ))}
      </div>
    </CustomerLayout>
  );
}
